import React from 'react';
import '../styles/Header.css';

function Header() {
  return (
    <header className="header">
      
         <div className="header-text-overlay">
          <h1 className="blog-title">Christi’s Blog</h1>
        </div>
      
    </header>
  );
}

export default Header;










